import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MessageCircle, MapPin, Mail, Facebook, Instagram, Twitter, Linkedin } from 'lucide-react';
import { companyInfo } from '../mock';

const Footer = () => {
  const handleWhatsApp = () => {
    window.open(`https://wa.me/91${companyInfo.whatsapp}?text=Hi, I'm interested in your properties`, '_blank');
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer bg-gradient-to-b from-gray-900 to-black border-t border-gray-800">
      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_2a73fc45-adbf-44a6-8139-8de8d79a04e7/artifacts/09g17uyg_ChatGPT%20Image%20Jan%202%2C%202026%2C%2005_19_57%20PM.png" 
                alt="UNITYPRO HOMES Logo"
                className="h-16 w-auto object-contain"
              />
              <div>
                <h3 className="text-lg font-bold gradient-text">{companyInfo.name}</h3>
                <p className="text-orange-400 font-semibold text-xs">{companyInfo.slogan}</p>
              </div>
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed text-sm">
              Delhi's trusted property developers specializing in premium plots, homes, and commercial spaces.
            </p>
            <div className="flex space-x-3">
              <a href="#" className="social-icon">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="social-icon">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="social-icon">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="social-icon">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold text-white mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="footer-link">Home</Link></li>
              <li><Link to="/properties" className="footer-link">All Properties</Link></li>
              <li><Link to="/about" className="footer-link">About Us</Link></li>
              <li><Link to="/contact" className="footer-link">Contact Us</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold text-white mb-6">Our Services</h4>
            <ul className="space-y-3">
              <li className="footer-link">Residential Plots</li>
              <li className="footer-link">Homes & Villas</li>
              <li className="footer-link">Farmhouses</li>
              <li className="footer-link">Commercial Shops</li>
              <li className="footer-link">Property Management</li>
              <li className="footer-link">Legal Assistance</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold text-white mb-6">Contact Us</h4>
            <div className="space-y-4">
              <div className="flex items-start">
                <MapPin className="w-5 h-5 text-orange-400 mr-3 mt-1 flex-shrink-0" />
                <p className="text-gray-400 text-sm leading-relaxed">{companyInfo.address}</p>
              </div>
              
              <div>
                <div className="flex items-center mb-2">
                  <Phone className="w-5 h-5 text-orange-400 mr-3" />
                  <span className="text-gray-400 text-sm">Call Us:</span>
                </div>
                {companyInfo.phones.map((phone, idx) => (
                  <a 
                    key={idx}
                    href={`tel:+91${phone}`} 
                    className="footer-link block ml-8 mb-1"
                  >
                    +91 {phone}
                  </a>
                ))}
              </div>
              
              <div className="flex items-center">
                <MessageCircle className="w-5 h-5 text-orange-400 mr-3" />
                <button onClick={handleWhatsApp} className="footer-link">
                  WhatsApp: +91 {companyInfo.whatsapp}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Managing Director */}
        <div className="border-t border-gray-800 pt-8 mb-8">
          <div className="text-center">
            <p className="text-gray-400 mb-2">
              <span className="text-orange-400 font-semibold">{companyInfo.managingDirector}</span> - {companyInfo.designation}
            </p>
            <p className="text-gray-500 text-sm">
              Leading {companyInfo.name} with excellence and integrity
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              © {currentYear} {companyInfo.name} {companyInfo.tagline}. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <a href="#" className="footer-link text-sm">Privacy Policy</a>
              <a href="#" className="footer-link text-sm">Terms of Service</a>
              <a href="#" className="footer-link text-sm">Sitemap</a>
            </div>
          </div>
        </div>
      </div>

      {/* Floating WhatsApp Button */}
      <button
        onClick={handleWhatsApp}
        className="floating-whatsapp"
        aria-label="Chat on WhatsApp"
      >
        <MessageCircle className="w-6 h-6" />
      </button>
    </footer>
  );
};

export default Footer;